import React from "react";
import { FieldV4, SelectV4 } from "../common/ui";
import { requestTerms, type WalkInOptions } from "./registrationModelV4";

type Props = {
  options?: WalkInOptions;
  channel: string;
  requests: string[];
  requestsDisabled?: boolean;
  onChannel: (value: string) => void;
  onRequests: (values: string[]) => void;
};
/** Kept separate so appointment registration can reuse the same team message UI. */
const TeamMessageV4 = (props: Props) => {
  const latest = props.options?.latestChannel;
  return <section className="hv4-card">
    <h2 className="hv4-card-title">ข้อความถึงทีม</h2>
    <p className="hv4-reg-oe-sub">ไม่บังคับ · Request พิเศษ (เลือกหรือพิมพ์เอง) แสดงเป็นไอคอนใต้รูปผู้ป่วย</p>
    <div className="hv4-reg-oe-form">
      <FieldV4 label={latest?.items.length ? "ช่องทางที่รู้จักคลินิก" : "รู้จักคลินิกจากช่องทางไหน (ถามครั้งเดียว)"} htmlFor="hv4-reg-channel">
        {latest?.items.length ? <div id="hv4-reg-channel">
          {latest.items.map((item) => item.name).join(" · ")} (บันทึกโดย {latest.recorded_by || "-"})
        </div> : <SelectV4 id="hv4-reg-channel" search allowAdd placeholder="ยังไม่ได้ถาม"
          disabled={!latest} options={(props.options?.channels ?? []).map((item) => ({ value: item.id, text: item.name }))}
          value={props.channel} onChange={props.onChannel} />}
      </FieldV4>
      <FieldV4 label="Request พิเศษ (เลือกได้หลายรายการ หรือพิมพ์เอง)" htmlFor="hv4-reg-requests">
        <SelectV4 id="hv4-reg-requests" search multiple allChips allowAdd addControls placeholder="ยังไม่ได้เลือก"
          disabled={props.requestsDisabled ?? (!props.options?.specialRequests || props.options.requestsLoaded === false)}
          options={requestTerms(props.options).map((item) => ({ value: item.id, text: item.name }))}
          value={props.requests} onChange={props.onRequests} />
      </FieldV4>
    </div>
  </section>;
};
export default TeamMessageV4;
